import React from 'react';
import { Droppable } from './droppable';
import Task from './common/Task';

const CompletedTaskList = ({ completedTasks, isLoading, handleContextMenu, handleDelete }) => {
    return (
        <Droppable id="completed-pane">
            <div className='overflow-y-auto flex-grow max-h-[calc(100vh-300px)]'>
                {isLoading ? (
                    <p>Loading completed tasks...</p>
                ) : completedTasks && completedTasks.length > 0 ? (
                    [...completedTasks].reverse().map((task) => (
                        <Task
                            key={task.task_id}
                            task={task}
                            onContextMenu={handleContextMenu}
                            onDelete={() => handleDelete(task.task_id, 'completed')}
                            isDraggable={true}
                            isCompleted={true}
                        />
                    ))
                ) : (
                    <p>No completed tasks available.</p>
                )}
            </div>
        </Droppable>
    );
};

export default CompletedTaskList;